var $ = require("jquery");
var ScreenOption = /** @class */ (function () {
    function ScreenOption(element, name) {
        this.name = name;
        this.element = element;
        this.init();
    }
    ScreenOption.prototype.getInput = function () {
        return this.element.querySelector('input');
    };
    ScreenOption.prototype.init = function () {
        var _this = this;
        var input = this.getInput();
        if (input) {
            input.addEventListener('change', function () {
                _this.persist();
            });
        }
    };
    ScreenOption.prototype.persist = function () {
        return $.ajax({
            url: ajaxurl,
            method: 'POST',
            data: {
                action: 'ac_admin_screen_options',
                option_name: this.name,
                option_value: this.getInput().checked ? 1 : 0,
                _ajax_nonce: AC._ajax_nonce
            }
        });
    };
    return ScreenOption;
}());
export default ScreenOption;
